import { Link } from "react-router-dom";
import { Icon } from "../components/Icons.jsx";
import Seo from "../components/Seo.jsx";
import { fortyDayPlan } from "./_routes-data.js";
export { fortyDayPlan };

export default function FortyDay() {
  const features = [
    "Daily 10-minute practice",
    "Modern explanation of each technique",
    "Reflection question every day",
    "Downloadable journal (PDF)",
    "Weekly checkpoint reflections",
    "Desire and impulse reset prompts",
    "Sleep and stress practices woven in",
  ];
  const dots = Array.from({ length: 40 }, (_, i) => i + 1);
  return (
    <>
      <Seo
        title="40-Day Challenge · Simple Meditation World"
        description="40 doorways. 40 days. One inner shift. A practical meditation journey, rooted in ancient wisdom."
        path="/40-day-challenge"
      />
      <section className="section-night subtle" id="challenge" style={{ paddingTop: 80 }}>
        <div className="container">
          <div className="forty-wrap">
            <div>
              <span className="eyebrow" style={{ color: "var(--gold)", display: "block", marginBottom: 18 }}>The journey</span>
              <h1 className="serif" style={{ fontSize: "clamp(34px, 4.4vw, 56px)", lineHeight: 1.08, marginBottom: 22, fontWeight: 400, color: "var(--ivory)" }}>
                40 Days. <em style={{ color: "var(--gold)", fontStyle: "italic" }}>40 Doorways.</em><br /> One Inner Shift.
              </h1>
              <p style={{ color: "rgba(248,241,231,0.72)", fontSize: 17, lineHeight: 1.65 }}>
                One small practice per day, explained in modern language and rooted in ancient wisdom.
              </p>
              <div style={{ marginTop: 28, fontFamily: "var(--mono)", fontSize: 10.5, letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 14 }}>
                What you get
              </div>
              <div className="forty-feature-list">
                {features.map((f) => (
                  <div key={f} className="forty-feature"><span className="tick">✓</span> {f}</div>
                ))}
              </div>
              <div style={{ marginTop: 36, display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Link className="btn btn-primary" to="/40-day-challenge/day/1">Begin Day 1 {Icon.arrowSm()}</Link>
                <Link className="btn btn-secondary" to="/sign-in" style={{ background: "transparent", color: "var(--ivory)", border: "1px solid rgba(229,193,106,0.4)" }}>
                  Save Progress
                </Link>
              </div>
            </div>
            <div>
              <div className="forty-grid">
                {dots.map((n) => {
                  const bright = [7, 14, 21, 28, 40].includes(n);
                  return (
                    <Link key={n} to={`/40-day-challenge/day/${n}`} className={`forty-dot lit ${bright ? "bright" : ""}`}>
                      {n}
                    </Link>
                  );
                })}
              </div>
              <div style={{ marginTop: 22, fontSize: 12, color: "rgba(248,241,231,0.55)", fontFamily: "var(--mono)", letterSpacing: "0.12em", textTransform: "uppercase", textAlign: "center" }}>
                Milestone days · 7 · 14 · 21 · 28 · 40
              </div>
              <div style={{ marginTop: 32, fontFamily: "var(--mono)", fontSize: 10.5, letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 8 }}>
                First 5 Days · Preview
              </div>
              <div className="forty-days-list">
                {fortyDayPlan.slice(0, 5).map((day) => (
                  <Link to={`/40-day-challenge/day/${day.d}`} key={day.d} className="forty-day-row" style={{ textDecoration: "none", color: "inherit" }}>
                    <div className="fdr-num">{String(day.d).padStart(2, "0")}</div>
                    <div><div className="fdr-title">{day.title}</div></div>
                    <div className="fdr-fam">{day.family}</div>
                    <div className="fdr-time">10 min</div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
